import type { AxiosInstance } from 'axios';

export interface AudioStatusResponse {
  status: 'pending' | 'ready' | 'error';
  audioUrl?: string;
}

type AudioSynthesis = {
  kolSearchId: number | null;
  queryId: number | null;
};

export class AudioStatusClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  fetchAudioStatus = async (queryIdentifier: number): Promise<AudioStatusResponse> => {
    const response = await this.authenticatedClient.post('/chat/vocalize-audio', { queryIdentifier });
    return response.data;
  };

  startAsyncAudioSynthesis = async (data: AudioSynthesis): Promise<AudioStatusResponse> => {
    const response = await this.authenticatedClient.post('/chat/vocalize-async', data);
    return response.data;
  };

  startAsyncOpenAITTS = async (data: AudioSynthesis): Promise<AudioStatusResponse> => {
    const response = await this.authenticatedClient.post('/chat/vocalize-openai', data);
    return response.data;
  };
}
